import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from "@angular/forms";
import { UserProfile } from "@sharedV11/classes/users/userProfile/userProfile";
import { HttpErrorsService } from "@sharedV11/services/alerts/errors/http-errors.service";
import { EditUserProfileService } from "@sharedV11/services/components/editUserProfile/edit-user-profile.service";
import { GlobalServicCentros } from "@sharedV11/services/global/global.service centros";
import { PanelService } from "@sharedV11/services/panel/panel.service";
import { Translator } from "@sharedV11/services/translator/translator.service";
import { DualListComponent } from "angular-dual-listbox";
import { Subject } from "rxjs";
import { take, takeUntil } from "rxjs/operators";
import { SnackbarInfoService } from "../../../../shared/services/alerts/snackbar-info/snackbar-info.service";
import { ConectarApiService } from "@sharedV11/services/api/connection/conectar-api.service";

export interface ModuloListItem {
  ModuloId: number;
  NombreModulo: string;
  _name?: string;
  AplicacionId?: number;
  _id?: number;
}

export interface AplicacionPermisoUI {
  AplicacionId: number;
  NombreAplicacion: string;
  Modulos: ModuloPermisoUI[];
  modulosDisponibles: ModuloListItem[];
  modulosAsignados: ModuloListItem[];
  modulosPrincipalesTodos: ModuloListItem[];
  lastModulosAsignadosIds?: Set<number>;
}

export interface ModuloPermisoUI {
  ModuloId: number;
  ModuloPadreId?: number;
  NombreModulo: string;
  Acciones: { AccionId: number; NombreAccion: string; Activo: number }[];
}

@Component({
  selector: "app-profile-save",
  templateUrl: "./profile-save.component.html",
  styleUrls: ["./profile-save.component.scss"],
})
export class ProfileSaveComponent implements OnInit {
  loading = true;
  private ngUnsubscribe = new Subject();
  private isValidPrivilegiosVar = /^-?\d{1,9}(\.\d{1,2})?$/;

  @Input() pkId: any;
  @Input() mode: any;
  @Input() modificar: boolean;

  editUserProfileForm: FormGroup;
  userProfile: UserProfile;

  translation: any;

  //centros
  centrosSinAsignar = [];
  centrosAsignados = [];
  tipoCentros: any[] = [];
  format = {
    add: "Añadir",
    remove: "Borrar",
    all: "Todos",
    none: "Ninguno",
    direction: DualListComponent.LTR,
    draggable: true,
    locale: "es",
  };
  centros;

  // Permisos: árbol en memoria + accordion por aplicación
  permisosTree: AplicacionPermisoUI[] = [];
  tipoUsuarioPermisosModalVisible = false;
  aplicacionDesglose: AplicacionPermisoUI | null = null;
  moduloDesgloseId: number | null = null;

  @ViewChild("tipoUsuarioPermisosContainer")
  tipoUsuarioPermisosContainer: ElementRef<HTMLDivElement>;

  //centros
  constructor(
    private translator: Translator,
    private editUserProfileService: EditUserProfileService,
    private fb: FormBuilder,
    private cdRef: ChangeDetectorRef,
    private panelService: PanelService,
    private snackvar_service: SnackbarInfoService,
    private httpErrorService: HttpErrorsService,
    private gsCentros: GlobalServicCentros,
    public servicioAPI: ConectarApiService
  ) {}

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  ngAfterViewInit() {
    //this.initializeForms()
    this.cdRef.detectChanges();
  }

  ngOnInit(): void {
    void this.initializeTranslate();
    this.initializeFormWithoutData();
    void this.bootstrapAfterCentrosReady();
  }

  private async bootstrapAfterCentrosReady(): Promise<void> {
    await this.gsCentros.getCentros();
    this.manageForm(this.pkId, this.mode);
    this.initializeFormValidations();
  }

  get formControls() {
    return this.editUserProfileForm.controls;
  }

  async initializeTranslate() {
    this.translation = this.translator.GetTranslations();
    this.format = {
      add: this.translation.Anadir,
      remove: this.translation.Borrar,
      all: this.translation.Todos,
      none: this.translation.Ninguno,
      direction: DualListComponent.LTR,
      draggable: true,
      locale: "es",
    };
  }

  manageForm(pkId, mode) {
    if (mode == "I") {
      this.userProfile = this.editUserProfileForm.value;
      this.centrosSinAsignar = [...(this.gsCentros.filtrarTiposCentros() ?? [])];
      this.loadPermisosTree("0").then(() => {
        this.loading = false;
        this.valuedChanged();
        this.cdRef.detectChanges();
      });
    }
    if (pkId != undefined) {
      this.serviceCall(pkId);
    }
  }
 
  buildPermisosTreeFromPermisos(permisos: { Aplicaciones?: any[]; aplicaciones?: any[] } | null | undefined): void {
    const raw = permisos ?? null;
    const apps = raw?.Aplicaciones ?? raw?.aplicaciones ?? [];
    this.permisosTree = (apps || []).map((a: any) => this.normalizeAppForTree(a));
    this.permisosTree.forEach((app) => this.refreshModulosListsForApp(app));
    this.cdRef.detectChanges();
  }

  
  async loadPermisosTree(tipoPkId: string | number): Promise<void> {
    const pkIdStr = String(tipoPkId);
    const isNewProfile = pkIdStr === "0";
    try {
  
      let res: any;
      try {
        res = await this.editUserProfileService.findUserByPkId(pkIdStr).pipe(take(1)).toPromise();
      } catch {
        res = null;
      }
      let tipo = res?.DatosResult?.tipoUsuarios?.[0];
      let permisos = tipo?.Permisos ?? tipo?.permisos;
      let apps = permisos?.Aplicaciones ?? permisos?.aplicaciones ?? [];

      let usedFallback = false;
      if (isNewProfile && (!apps || apps.length === 0)) {
        const listRes = await this.servicioAPI.getTiposUsuario().pipe(take(1)).toPromise();
        const tipos = listRes?.DatosResult?.tipoUsuarios ?? [];
        const firstPkId = tipos.length > 0 ? String(tipos[0].pkId) : null;
        if (firstPkId) {
          const refRes = await this.editUserProfileService.findUserByPkId(firstPkId).pipe(take(1)).toPromise();
          tipo = refRes?.DatosResult?.tipoUsuarios?.[0];
          permisos = tipo?.Permisos ?? tipo?.permisos;
          apps = permisos?.Aplicaciones ?? permisos?.aplicaciones ?? [];
          usedFallback = true;
        }
      }

      this.permisosTree = (apps || []).map((a: any) => this.normalizeAppForTree(a));
      if (isNewProfile && usedFallback && this.permisosTree.length > 0) {
        this.clearAllPermisosInTree();
      }
      this.permisosTree.forEach((app) => this.refreshModulosListsForApp(app));
      this.cdRef.detectChanges();
    } catch {
      this.permisosTree = [];
      this.cdRef.detectChanges();
    }
  }

  private clearAllPermisosInTree(): void {
    for (const app of this.permisosTree) {
      for (const mod of app.Modulos || []) {
        for (const acc of mod.Acciones || []) {
          acc.Activo = 0;
        }
      }
    }
  }

  private normalizeAppForTree(a: any): AplicacionPermisoUI {
    const modulosRaw = a.Modulos ?? a.modulos ?? [];
    const modulos: ModuloPermisoUI[] = (modulosRaw || []).map((m: any) => ({
      ModuloId: Number(m.ModuloId),
      ModuloPadreId: m.ModuloPadreId != null ? Number(m.ModuloPadreId) : 0,
      NombreModulo: this.normalizeNombreModulo(m),
      Acciones: (m.Acciones ?? m.acciones ?? []).map((ac: any) => ({
        AccionId: ac.AccionId ?? ac.accionId,
        NombreAccion: ac.NombreAccion ?? ac.nombreAccion ?? "",
        Activo: Number(ac.Activo ?? ac.activo ?? 0) === 1 ? 1 : 0,
      })),
    }));
    return {
      AplicacionId: a.AplicacionId ?? a.aplicacionId,
      NombreAplicacion: a.NombreAplicacion ?? a.nombreAplicacion ?? "",
      Modulos: modulos,
      modulosDisponibles: [],
      modulosAsignados: [],
      modulosPrincipalesTodos: [],
    };
  }
  
  private normalizeNombreModulo(m: any): string {
    const name = m.NombreModulo ?? m.nombreModulo ?? "";
    return typeof name === "string" ? name.trim() : String(name || "");
  }

  private isModuloPrincipal(mod: ModuloPermisoUI): boolean {
    const padreId = mod.ModuloPadreId;
    if (padreId == null || padreId === undefined) return true;
    return Number(padreId) === 0;
  }

  private getPrincipalesParaLista(app: AplicacionPermisoUI): ModuloPermisoUI[] {
    const modulos = app.Modulos || [];
    const idsEnLista = new Set(modulos.map((m) => Number(m.ModuloId)));
    return modulos.filter((m) => {
      const padreId = Number(m.ModuloPadreId);
      return padreId === 0 || !idsEnLista.has(padreId);
    });
  }

  private getSubmodulos(app: AplicacionPermisoUI, moduloId: number): ModuloPermisoUI[] {
    return (app.Modulos || []).filter((m) => Number(m.ModuloPadreId) === Number(moduloId));
  }

  private hasAnyActionActive(mod: ModuloPermisoUI): boolean {
    return (mod.Acciones || []).some((a) => Number(a.Activo) === 1);
  }

  private isModuloActive(app: AplicacionPermisoUI, mod: ModuloPermisoUI): boolean {
    const principales = this.getPrincipalesParaLista(app);
    if (!principales.some((p) => p.ModuloId === mod.ModuloId)) return false;
    if (this.hasAnyActionActive(mod)) return true;
    if (this.isModuloPrincipal(mod))
      return this.getSubmodulos(app, mod.ModuloId).some((sub) => this.hasAnyActionActive(sub));
    return false;
  }


  refreshModulosListsForApp(app: AplicacionPermisoUI): void {
    const principales = this.getPrincipalesParaLista(app);
    app.modulosPrincipalesTodos = principales.map((m) => this.moduloToListItem(m, app.AplicacionId));
    app.modulosDisponibles = principales
      .filter((m) => !this.isModuloActive(app, m))
      .map((m) => this.moduloToListItem(m, app.AplicacionId));
    app.modulosAsignados = principales
      .filter((m) => this.isModuloActive(app, m))
      .map((m) => this.moduloToListItem(m, app.AplicacionId));
    app.lastModulosAsignadosIds = new Set(app.modulosAsignados.map((m) => m.ModuloId));
  }

  private setAllAccionesForModuloAndSubmodulos(
    app: AplicacionPermisoUI,
    mod: ModuloPermisoUI,
    value: 0 | 1
  ): void {
    (mod.Acciones || []).forEach((a) => (a.Activo = value));
    this.getSubmodulos(app, mod.ModuloId).forEach((sub) =>
      this.setAllAccionesForModuloAndSubmodulos(app, sub, value)
    );
  }

  private moduloToListItem(mod: ModuloPermisoUI, aplicacionId: number): ModuloListItem {
    const nombre = (mod.NombreModulo ?? "").trim() || String(mod.ModuloId);
    return {
      ModuloId: mod.ModuloId,
      NombreModulo: mod.NombreModulo ?? "",
      _name: nombre,
      AplicacionId: aplicacionId,
    };
  }

  
  onModulosMoved(app: AplicacionPermisoUI): void {
    setTimeout(() => {
      const previousIds = app.lastModulosAsignadosIds || new Set<number>();
      const currentIds = new Set((app.modulosAsignados || []).map((m) => m.ModuloId));
      const added = [...currentIds].filter((id) => !previousIds.has(id));
      const removed = [...previousIds].filter((id) => !currentIds.has(id));
      const modById = new Map((app.Modulos || []).map((m) => [m.ModuloId, m]));
      const principalesIds = new Set(this.getPrincipalesParaLista(app).map((m) => m.ModuloId));

      added.forEach((modId) => {
        const mod = modById.get(modId);
        if (mod && principalesIds.has(modId)) {
          app.modulosDisponibles = (app.modulosDisponibles || []).filter((m) => m.ModuloId !== modId);
        }
      });
      removed.forEach((modId) => {
        const mod = modById.get(modId);
        if (mod && principalesIds.has(modId)) {
          this.setAllAccionesForModuloAndSubmodulos(app, mod, 0);
          const item = this.moduloToListItem(mod, app.AplicacionId);
          if (!(app.modulosDisponibles || []).some((m) => m.ModuloId === modId))
            app.modulosDisponibles = [...(app.modulosDisponibles || []), item];
        }
      });
      app.lastModulosAsignadosIds = new Set(currentIds);
      this.cdRef.detectChanges();
    }, 0);
  }

  openDesgloseModulo(app: AplicacionPermisoUI, item: any): void {
    const moduloId = item?.ModuloId ?? item?._id;
    if (moduloId == null) return;
    this.aplicacionDesglose = app;
    this.moduloDesgloseId = moduloId;
    this.tipoUsuarioPermisosModalVisible = true;
    this.cdRef.detectChanges();

    setTimeout(() => {
      const container = this.tipoUsuarioPermisosContainer?.nativeElement;
      if (!container) {
        return;
      }

      container.scrollTop = 0;

      const overlay = container.parentElement as HTMLElement | null;
      if (overlay && typeof overlay.scrollTo === "function") {
        overlay.scrollTo({ top: 0, behavior: "smooth" });
      }

      container.scrollIntoView({
        block: "start",
        inline: "nearest",
        behavior: "smooth",
      });
    });
  }

  openDesgloseModuloFromItem(item: any): void {
    const moduloId = item?.ModuloId ?? item?._id;
    if (moduloId == null) return;
    let app: AplicacionPermisoUI | undefined =
      item?.AplicacionId != null
        ? this.permisosTree.find((a) => a.AplicacionId === item.AplicacionId)
        : undefined;
    if (!app) {
      app = this.permisosTree.find((a) =>
        (a.modulosAsignados || []).some(
          (m) => (m?.ModuloId ?? m?._id) === moduloId
        )
      );
    }
    if (app) this.openDesgloseModulo(app, item);
  }

  private moduleHasAnyActivePermission(app: AplicacionPermisoUI, moduloId: number): boolean {
    const modulos = app?.Modulos || [];
    const principal = modulos.find(
      (m) => Number(m.ModuloId) === Number(moduloId) && this.isModuloPrincipal(m)
    ) || modulos.find((m) => Number(m.ModuloId) === Number(moduloId));
    if (!principal) return false;
    if ((principal.Acciones || []).some((a) => a.Activo === 1)) return true;
    const submodulos = modulos.filter((m) => Number(m.ModuloPadreId) === Number(moduloId));
    return submodulos.some((sub) => (sub.Acciones || []).some((a) => a.Activo === 1));
  }

  onTipoUsuarioPermisosSave(): void {
    const app = this.aplicacionDesglose;
    const moduloId = this.moduloDesgloseId;
  
    if (app != null && moduloId != null && !this.moduleHasAnyActivePermission(app, moduloId)) {
      app.modulosAsignados = (app.modulosAsignados || []).filter(
        (m) => (m.ModuloId ?? m._id) !== moduloId
      );
      
      app.lastModulosAsignadosIds = new Set((app.modulosAsignados || []).map((m) => m.ModuloId));
    }
    this.tipoUsuarioPermisosModalVisible = false;
    this.aplicacionDesglose = null;
    this.moduloDesgloseId = null;
    this.cdRef.detectChanges();
  }

  onTipoUsuarioPermisosCancel(): void {
    this.tipoUsuarioPermisosModalVisible = false;
    this.aplicacionDesglose = null;
    this.moduloDesgloseId = null;
  }

  private static readonly CARACTERES_PROHIBIDOS = ['--', ';', '/*', '*/', '@@'];

  static caracteresProhibidosValidator(control: AbstractControl): ValidationErrors | null {
    const v = (control.value ?? "").toString();
    if (!v) return null;
    const encontrado = ProfileSaveComponent.CARACTERES_PROHIBIDOS.find((seq) => v.includes(seq));
    return encontrado ? { caracteresProhibidos: { secuencia: encontrado } } : null;
  }


  static sanitizarCaracteresProhibidos(valor: string): string {
    let s = (valor ?? "").toString();
    ProfileSaveComponent.CARACTERES_PROHIBIDOS.forEach((seq) => {
      s = s.split(seq).join("");
    });
    return s;
  }

  private static readonly MAX_LENGTH_NOMBRE = 20;
  private static readonly MAX_LENGTH_DESCRIPCION = 50;

  initializeFormValidations() {
    this.formControls.Nombre.setValidators([
      Validators.required,
      Validators.maxLength(ProfileSaveComponent.MAX_LENGTH_NOMBRE),
      ProfileSaveComponent.caracteresProhibidosValidator,
    ]);
    this.formControls.Descripcion.setValidators([
      Validators.maxLength(ProfileSaveComponent.MAX_LENGTH_DESCRIPCION),
      ProfileSaveComponent.caracteresProhibidosValidator,
    ]);
  }

  /*  initializeFormWithData(userProfile:UserProfile){
     this.editUserProfileForm= this.fb.group({
       pkId:[userProfile.pkId],
       Nombre:[userProfile.Nombre],
       Descripcion:[userProfile.Descripcion],
       Privilegios:[userProfile.Privilegios]
     });
   } */
  initializeFormWithoutData() {
    this.editUserProfileForm = this.fb.group({
      pkId: [""],
      Nombre: [""],
      Descripcion: [""],
      // Privilegios: [""],
      idTyp: [{ value: '', disabled: true }],
    });
  }

  serviceCall(pkId) {
    this.editUserProfileService
      .findUserByPkId(pkId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        async (userprofileApi) => {
          let userProfile = userprofileApi["DatosResult"]["tipoUsuarios"][0];
          if (userProfile != null) {
            this.changeValueForm(userProfile);
            this.userProfile = userProfile;
            this.valuedChanged();
            await this.gsCentros.getCentros();
            this.centrosSinAsignar = [...(this.gsCentros.filtrarTiposCentros() ?? [])];
            this.centrosAsignados = [...(this.gsCentros.daTiposCentros(this.userProfile) ?? [])];

            const permisos = userProfile.Permisos ?? userProfile.permisos;
            const aplicaciones = permisos?.Aplicaciones ?? permisos?.aplicaciones;
            if (aplicaciones?.length) {
              this.buildPermisosTreeFromPermisos(permisos);
            } else {
              await this.loadPermisosTree(this.userProfile.pkId);
            }
            this.loading = false;
            this.cdRef.detectChanges();
          }
        },
        (error) => {
          this.httpErrorService.identificarErrores(error);
        }
      );
  }

  changeValueForm(userProfile: UserProfile) {
    this.formControls["pkId"].setValue(userProfile.pkId);
    this.formControls["Nombre"].setValue(userProfile.Nombre);
    this.formControls["Descripcion"].setValue(userProfile.Descripcion);
    // this.formControls["Privilegios"].setValue(userProfile.Privilegios);
    this.formControls["idTyp"].setValue(userProfile.idTyp);
  }

  submit() {
    let user: UserProfile = this.editUserProfileForm.value;

    this.editUserProfileForm.markAllAsTouched();
    if (this.editUserProfileForm.valid) {
      user.CentrosIds = this.gsCentros.obtenercentrosAsociadosconOrden(
        this.centrosAsignados
      );

      this.manageApi(user, this.mode);
    }
  }
  destroy() {
    this.panelService.setDiscardChanges(true);
    this.loading = false;
    this.panelService.setClosePanel(null);
  }

  save() {
    this.loading = false;
    this.panelService.setSavePanel(null);
  }
  discard() {
    this.changeValueForm(this.userProfile);
  }

  manageApi(userProfile: UserProfile, mode) {
    this.loading = true;
    const pkId = mode === "I" || mode === "D" ? "0" : String(userProfile?.pkId ?? "");
    const funcion = pkId === "0" ? "I" : "U";
    this.saveProfileWithPermisos({ ...userProfile, pkId }, funcion);
  }

  private saveProfileWithPermisos(userProfile: UserProfile, funcion: "I" | "U"): void {
    const permisos: Array<{ AplicacionId: number; ModuloId: number; AccionId: number }> = [];
    for (const app of this.permisosTree) {
      const assignedIds = new Set((app.modulosAsignados || []).map((m) => m.ModuloId));
      const isModuloOrSubmoduleAssigned = (mod: ModuloPermisoUI): boolean => {
        if (assignedIds.has(mod.ModuloId)) return true;
        const principalId = Number(mod.ModuloPadreId);
        return principalId !== 0 && assignedIds.has(principalId);
      };
      for (const mod of app.Modulos || []) {
        if (!isModuloOrSubmoduleAssigned(mod)) continue;
        for (const acc of mod.Acciones || []) {
          if (acc.AccionId && acc.Activo === 1) {
            permisos.push({
              AplicacionId: app.AplicacionId,
              ModuloId: mod.ModuloId,
              AccionId: acc.AccionId,
            });
          }
        }
      }
    }
    this.servicioAPI
      .insertarActualizarTipoUsuariosConPermisos({
        pkId: String(userProfile.pkId ?? ""),
        Nombre: userProfile.Nombre ?? "",
        Descripcion: userProfile.Descripcion ?? "",
        CentrosIds: userProfile.CentrosIds ?? "",
        Permisos: permisos,
        Funcion: funcion,
      })
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (response) => {
          if (response?.DatosResult != null) {
            const newId = response.DatosResult?.id ?? response.DatosResult?.pkId;
            if (funcion === "I" && newId != null)
              this.formControls["pkId"].setValue(newId);
            this.nextWindow(response);
          } else {
            const msg = response?.Mensajes?.[0];
            if (msg)
              this.snackvar_service.openSnackBar(
                msg.DescripcionMensaje,
                "",
                "red-snackbar",
                msg.CodigoMensaje
              );
          }
          this.loading = false;
        },
        (error) => {
          this.httpErrorService.identificarErrores(error);
          this.loading = false;
        }
      );
  }

  notEmptyFields(user: UserProfile): boolean {
    let res = true;
    if (user.Nombre.length === 0) {
      res = false;
    }
    return res;
  }

  nextWindow(response: any) {
    const err = this.existErrors();
    if (!this.existErrors()) {
      this.save();
      this.destroy();
      if (response.Mensajes.length > 0) {
        console.table("response.Mensajes::", response.Mensajes);
        response.Mensajes.forEach((element) => {
          this.snackvar_service.openSnackBar(
            element.DescripcionMensaje,
            "",
            "red-snackbar",
            element.CodigoMensaje
          );
        });
      } else {
        this.snackvar_service.openSnackBar(
          this.translation["MensajeSuccessSnackBar"],
          "",
          "green-snackbar"
        );
      }
    }
  }

  valuedChanged() {
    this.editUserProfileForm.valueChanges.subscribe((value) => {
      if (this.userProfile != null) {
        this.panelService.setDiscardChanges(false);
        if (JSON.stringify(value) === JSON.stringify(this.userProfile)) {
          this.panelService.setDiscardChanges(true);
        }
      }
    });
  }

  validateFields(field: string) {
    return this.isValidAnyField(field);
  }

  existErrors() {
    return this.formControls.Nombre.errors ||
      // this.formControls.Privilegios.errors ||
      this.formControls.Descripcion.errors
      ? true
      : false;
  }

  isValidAnyField(field: string) {
    let fc_pv = this.formControls;
    return fc_pv[field].errors != null || fc_pv[field].invalid ? true : false;
  }

  getErrorMessage(field: string) {
    let mensaje: string;
    const fc_pv = this.editUserProfileForm.get(field);
    if (fc_pv?.errors) {
      if (fc_pv.errors.required) {
        mensaje = this.translation["CampoRequerido"];
      } else if (fc_pv.hasError("maxlength")) {
        const requiredLength = fc_pv.errors.maxlength?.requiredLength ?? 0;
        mensaje =
          (this.translation["MaximoCaracteres"] || this.translation["Maximo"] || "Máximo") +
          " " +
          requiredLength +
          " " +
          (this.translation["CaracteresPermitidos"] || "caracteres permitidos");
      } else if (fc_pv.hasError("pattern")) {
        mensaje = this.translation["SoloNumeros"];
      } else if (fc_pv.hasError("caracteresProhibidos")) {
        const seq = fc_pv.errors.caracteresProhibidos?.secuencia ?? "";
        const msg =
          this.translation["CaracteresNoPermitidos"] ||
          "No se permiten los caracteres: -- ; /* */ @@. Carácter bloqueado: ";
        mensaje = msg + `"${seq}"`;
      }
    }
    return mensaje ?? "";
  }

  onNombreInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const valor = input.value ?? "";
    const sanitizado = ProfileSaveComponent.sanitizarCaracteresProhibidos(valor);
    if (sanitizado !== valor) {
      const ctrl = this.editUserProfileForm.get("Nombre");
      if (ctrl) {
        ctrl.setValue(sanitizado, { emitEvent: true });
        input.value = sanitizado;
      }
    }
  }

  onDescripcionInput(event: Event): void {
    const input = event.target as HTMLTextAreaElement;
    const valor = input.value ?? "";
    const sanitizado = ProfileSaveComponent.sanitizarCaracteresProhibidos(valor);
    if (sanitizado !== valor) {
      const ctrl = this.editUserProfileForm.get("Descripcion");
      if (ctrl) {
        ctrl.setValue(sanitizado, { emitEvent: true });
        input.value = sanitizado;
      }
    }
  }
}
